import { AppDispatch, AppState } from "features/state";
import { createRoleActions } from "../reducers/fakeRoleReducer";
import { getRolesApi } from "../api/getRolesApi";

export const getRolesAction = () => async (dispatch: AppDispatch, getState: () => AppState) => {
    const roles = await getRolesApi();

    dispatch(createRoleActions.setFakeRoles(roles));
};
